<template>
    <v-container fluid>
        <div class="tables-basic">
            <h1 class="page-title mt-10 mb-6">Rejestr zgłoszeń</h1>

            <ErrorSubscription :isCustomerActive="isCustomerActive()" />

            <v-row v-if="isCustomerActive()">
                <v-col cols="12">
                    <v-card class="employee-list mb-1">
                        <v-card-title class="pa-6 pb-3">
                            <p>Zgłoszenia</p>
                            <v-spacer></v-spacer>
                            <v-btn text @click="getAllReports()" :disabled="newSignals.selected == undefined || newSignals.selected.length == 0" v-if="adminCanReports">
                                <v-icon color="red">mdi-file-multiple</v-icon><div>Pobierz rejestr (.CSV)</div>
                            </v-btn>
                            <v-spacer></v-spacer>
                            <span class="report-category">Kategoria:</span><v-select v-model="selectedCategory" :items="categories" item-text="catName" item-value="catId" @change="showFromCategory($event)" dense class="report-category-select"></v-select>
                            <v-spacer></v-spacer>
                            <v-text-field v-model="newSignals.search"
                                          append-icon="mdi-magnify"
                                          label="Szukaj w widocznych"
                                          clearable
                                          single-line
                                          class="report-text-field"
                                          hide-details></v-text-field>
                        </v-card-title>
                        <v-data-table v-model="newSignals.selected"
                                      :headers="withSignalNumber(newSignals.headers, newSignals.signals)"
                                      :items="filteredSignals"
                                      :show-select="adminCanReports"
                                      item-key="id"
                                      :loading="loading"
                                      loading-text="Ładowanie... Proszę czekać"
                                      :items-per-page.sync="itemsPerPage"
                                      :hide-default-footer="false"
                                      :expanded.sync="expanded"
                                      :server-items-length="totalItems"
                                      @update:page="handlePageUpdate"
                                      show-expand
                                      :footer-props="{'items-per-page-options': [10, 20, 30, 40, -1], 'items-per-page-text': 'Załaduj wiersze' }">

                            <template v-slot:[`item.actions`]="{ item }">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <v-btn text @click="showSignal(item)" v-on="on">
                                            <v-icon color="green">mdi-open-in-new</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>ZGŁOSZENIE</span>
                                </v-tooltip>
                            </template>

                            <template v-slot:expanded-item="{ headers, item }">
                                <td :colspan="headers.length">
                                    <p>Informacje dodatkowe:</p>
                                    <p class="report-margin-bottom-0">Etykieta zgłoszenia: {{ item.title }}</p>
                                    <p class="report-margin-bottom-0">Dane sygnalisty: {{ item.sygnalistName != null && item.sygnalistName.length > 0 ? item.sygnalistName : 'Brak danych personalnych' }} {{ item.sygnalistEmail != null && item.sygnalistEmail.length > 0 ? '(e-mail: '+item.sygnalistEmail+')' : '(brak wskazanego adresu email)' }} {{item.sygnalistPhone != null && item.sygnalistPhone.length > 0 ? '(telefon: '+item.sygnalistPhone+')' : '(brak wskazanego numeru telefonu)'}}</p>
                                    <p class="report-margin-bottom-0" v-if="item.msgDecode != null && item.msgDecode.length > 0 && item.msgDecode != 'Brak danych'">Przedmiot naruszenia prawa: {{ item.msgDecode }}</p>
                                    <p class="report-margin-bottom-0" v-if="item.msgRequireDecode != null && item.msgRequireDecode.length > 0 && item.msgRequireDecode != 'Brak danych'">Żądanie wydania zaświadczenia o podleganiu ochronie (art. 38 ustawy): {{ item.msgRequireDecode == 'on' ? 'TAK' : 'NIE' }}</p>
                                    <p v-if="item.msgPersonDecode != null && item.msgPersonDecode.length > 0 && item.msgPersonDecode != 'Brak danych'">Dane osoby, której dotyczy zgłoszenie: {{ item.msgPersonDecode }}</p>
                                    <p class="report-margin-bottom-0" v-if="item.notes !== null && item.notes.length > 0">Działania następcze:</p>
                                    <div v-if="item.notes !== null && item.notes.length > 0">
                                        <p v-for="i in item.notes" :key="i.id" class="report-margin-bottom-5">
                                            Data: <b>{{formatDateToDisplay(i.date)}}</b> - Administrator: <b>{{i.adminName}}</b> - Treść: <b>{{i.text}}</b>
                                        </p>
                                    </div>
                                    <p class="report-margin-bottom-0" v-if="item.propertyDamageInfos !== null && item.propertyDamageInfos.length > 0">Informacje o szkodzie majątkowej:</p>
                                    <div v-if="item.propertyDamageInfos !== null && item.propertyDamageInfos.length > 0">
                                        <p v-for="i in item.propertyDamageInfos" :key="i.id" class="report-margin-bottom-5">
                                            Data: <b>{{formatDateToDisplay(i.date)}}</b> - Administrator: <b>{{i.adminName}}</b> - Treść: <b>{{i.text}}</b>
                                        </p>
                                    </div>
                                </td>
                            </template>
                        </v-data-table>
                  </v-card>
              </v-col>
          </v-row>

      </div>
  </v-container>
</template>

<script>
    import CryptoJS from 'crypto-js'
    import Service from '@/services/Service'
    import ErrorSubscription from '@/components/Modals/ErrorInfoSubscription.vue'
    import signalNumber from '@/mixins/signalNumber'
    export default {
        name: 'Reports',
        components: {
            ErrorSubscription
        },
        mixins: [signalNumber],
        data() {
            return {
                newSignals: {
                    selected: [],
                    search: '',
                    headers: [
                        {
                            text: 'Identyfikator',
                            align: 'start',
                            sortable: false,
                            value: 'identifier',
                        },
                        { text: 'Data wpływu', value: 'datetime', sortable: false },
                        { text: 'Data zakończenia', value: 'archiveTime', sortable: false },
                        { text: 'Status', value: 'statusForReport', sortable: false },
                        { text: 'Kategoria', value: 'category', sortable: false },
                        { text: '', value: 'actions', sortable: false },
                    ],
                    signals: [],

                },
                signals: [],
                adminCanReports: false,
                itemsPerPage: 10,
                totalItems: 20,
                pageNumber: 1,
                loading: true,
                expanded: [],
                singleExpand: false,
                messages: [],
                categories: [
                    {
                        catId: 0,
                        catName: "Wszystkie"
                    }
                ],
                selectedCategory: 0
            }
        },
        computed: {
            filteredSignals() {
                const searchText = this.newSignals.search.toLowerCase();
                return this.newSignals.signals.filter(signal => Object.values(signal).some(value => String(value).toLowerCase().includes(searchText)));
            },
        },
        async mounted() {
            try {

                if (this.isCustomerActive()) {
                    this.main = (await Service.getAllSignals(this.itemsPerPage, this.pageNumber, this.selectedCategory)).data,
                        this.signalsDb = this.main.signals,
                        this.totalItems = this.main.totalItems,
                        this.adminCanReports = this.main.login.canReports,
                        this.newSignals = {
                            selected: [],
                            search: '',
                            headers: [
                                {
                                    text: 'Identyfikator',
                                    align: 'start',
                                    sortable: false,
                                    value: 'identifier',
                                },
                                { text: 'Data wpływu', value: 'datetime', sortable: false },
                                { text: 'Data zakończenia', value: 'archiveTime', sortable: false },
                                { text: 'Status', value: 'statusForReport', sortable: false },
                                { text: 'Kategoria', value: 'category', sortable: false },
                                { text: '', value: 'actions', sortable: false },
                            ],
                            signals: this.signalsDb,

                        };

                        for (var i = 0; i < this.newSignals.signals.length; i++) {
                            var temp = this.odszyfruj(this.newSignals.signals[i]);
                            this.newSignals.signals[i].msgDecode = temp[0];
                            this.newSignals.signals[i].msgPersonDecode = temp[1];
                            this.newSignals.signals[i].msgRequireDecode = temp[2];
                        }

                        await this.getCategoriesList();

                        this.loading = false
                }

            } catch (e) {
                if (e.response.status == 401)
                    this.$router.push({ name: 'Login' })
            }
        },
        watch: {
            itemsPerPage: {
                async handler() {
                    //if (this.itemsPerPage > 10 || this.itemsPerPage == -1) {
                        await this.loadRecords();
                    //}
                },
                deep: true,
            }
        },
        methods: {
            async showFromCategory(event) {
                try {
                    this.selectedCategory = event;
                    await this.loadRecords();
                } catch (e) {
                    alert(e.response.status + " - " + e.response.data.toString());
                    if (e.response.status == 401)
                        this.$router.push({ name: 'Login' })
                }
            },
            async getCategoriesList() {
                try {
                    var result = (await Service.getCategoriesList()).data;
                    if (Object.keys(result).length > 0) {
                        result.forEach(obj => this.categories.push(obj));
                    }
                } catch (e) {
                    alert(e.response.status + " - " + e.response.data.toString());
                    if (e.response.status == 401)
                        this.$router.push({ name: 'Login' })
                }
            },
            async handlePageUpdate(newPage) {
                this.pageNumber = newPage;
                await this.loadRecords();
            },
            formatDateToDisplay(value) {
                var date = new Date(value)
                var d = date.toLocaleString('default', {
                    year: 'numeric',
                    month: 'long',
                    weekday: 'long',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric'
                });

                return d;
            },
            odszyfruj(result) {
                try {
                    var k = result.pkid;
                    var s = result.msg;

                    if (k != "0") {
                        var x = this.decrypt(k, s);
                        const arr = JSON.parse(x);

                        var elem1 = "Brak danych";
                        var elem2 = "Brak danych";
                        var elem3 = "Brak danych";

                        var tempArr = arr.find(x => x.name.includes("Przedmiot naruszenia prawa"));
                        if (tempArr !== undefined)
                            elem1 = tempArr.value;

                        var tempPerson = arr.find(x => x.name.includes("Dane osoby, której dotyczy zgłoszenie"));
                        if (tempPerson !== undefined)
                            elem2 = tempPerson.value;

                        if (result.category.toLowerCase() === "zgłoszenia zewnętrzne") {
                            var tempRequire = arr.find(x => x.name.includes("Żądanie wydania zaświadczenia o podleganiu ochronie (art. 38 ustawy)"));
                            if (tempRequire !== undefined)
                                elem3 = tempRequire.value;
                            else
                                elem3 = "off";
                        }
                        
                        return [elem1, elem2, elem3];

                    } else {
                        var text = '';
                        if (result.type == 2)
                            text = 'Zgłoszenie telefoniczne';
                        else if (result.type == 3)
                            text = 'Zgłoszenie email';
                        else
                            text = 'Zgłoszenie';

                        return ["Brak danych, inny typ zgłoszenia (" + text + ")", "Brak danych, inny typ zgłoszenia (" + text + ")"];
                    }
                } catch (error) {
                    return ["Brak danych", "Brak danych", "Brak danych"];
                }
            },
            decrypt(key, message) {
                var m = this.b64decode(message);
                const arr = JSON.parse(m);
                for (var item of arr) {
                    var n = item.name;
                    var v = item.value;
                    if (this.right(n, 10) == '_encrypted' && v != '') {
                        var bytes = CryptoJS.AES.decrypt(v, key);
                        var result = bytes.toString(CryptoJS.enc.Utf8);
                        item.value = result;
                        item.name = item.name.replace("_encrypted", "_decrypted")
                    }
                }
                return JSON.stringify(arr)
            },
            right(str, chr) {
                return str.slice(str.length - chr, str.length);
            },
            b64decode(x) {
                var result = decodeURIComponent(escape(window.atob(x)));
                return result;
            },
            isCustomerActive() {
                return this.$store.state.admin.customerIsActive;
            },
            showSignal(item) {
                this.$router.push({ name: 'Signal', params: { identifier: item.id } })
            },
            async getAllReports() {
                try {
                    var result = (await Service.downloadReportToFile(this.newSignals.selected));

                    var date = new Date();
                    var fileName = "rejestr_zgloszen_" + date.getFullYear() + "_" + date.getMonth() + "_" + date.getDate() + "_" + date.getHours() + "_" + date.getMinutes() + "_" + date.getSeconds();

                    if (result.status == 200) {
                        const contentType = result.headers['content-type'];
                        var a = document.createElement('a');
                        var blob = new Blob([result.data], { 'type': contentType });
                        a.href = window.URL.createObjectURL(blob);
                        a.download = fileName;
                        a.click();
                    }
                } catch (e) {
                    alert(e.response.status + " - " + e.response.data.toString());
                    if (e.response.status == 401)
                        this.$router.push({ name: 'Login' })
                }

                //localStorage["reportsToPrintForAdmin"] = JSON.stringify(this.newSignals.selected);
                //let routeData = this.$router.resolve({ name: 'reportPrint' });
                //window.open(routeData.href, '_blank');
            },
            async loadRecords() {
                try {

                    this.loading = true;
                    this.main = (await Service.getAllSignals(this.itemsPerPage, this.pageNumber, this.selectedCategory)).data;
                    this.signalsDb = this.main.signals,
                    this.totalItems = this.main.totalItems,
                    this.adminCanReports = this.main.login.canReports,
                    this.newSignals = {
                        selected: [],
                        search: '',
                        headers: [
                            {
                                text: 'Identyfikator',
                                align: 'start',
                                sortable: false,
                                value: 'identifier',
                            },
                            { text: 'Data wpływu', value: 'datetime', sortable: false },
                            { text: 'Data zakończenia', value: 'archiveTime', sortable: false },
                            { text: 'Status', value: 'statusForReport', sortable: false },
                            { text: 'Kategoria', value: 'category', sortable: false },
                            { text: '', value: 'actions', sortable: false },
                        ],
                        signals: this.signalsDb,

                    };

                    for (var i = 0; i < this.newSignals.signals.length; i++) {
                        var temp = this.odszyfruj(this.newSignals.signals[i]);
                        this.newSignals.signals[i].msgDecode = temp[0];
                        this.newSignals.signals[i].msgPersonDecode = temp[1];
                        this.newSignals.signals[i].msgRequireDecode = temp[2];
                    }

                    this.loading = false;
                } catch (e) {
                    console.log(e)
                    if (e.response.status == 401)
                        this.$router.push({ name: 'Login' })
                }
            }
        }
    }

</script>

<style src="./Basic.scss" lang="scss">
</style>
